import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: ${(props) =>
    props.isLoading ? "none" : "rgba(0, 0, 0, 0.8)"};
`;

function Backdrop({ opacity, color, children, isLoading = false }) {
  return <Wrapper isLoading={isLoading}>{children}</Wrapper>;
}

export default Backdrop;
